import { DesignSystem } from '@workbuddy/ui/v2/design-system';

// Design values for the bulk "Add Photo / Video Evidence" dialog: the stack of Before / During / After bucket
// sections and their headings. Scoped to the dialog element so the upload fields inside keep their own.

const tokens = DesignSystem.tokens;

export const itemEvidenceBulkDialogStyleId = 'job-item-evidence-bulk-dialog-theme';

export const itemEvidenceBulkDialogBridgeStyles = {
  'item-evidence-bulk-dialog': {
    // Three compact upload fields read as a column, not a band — the modal shell is far wider than they need.
    '--local-evidence-body-width': '560px',
    '--local-evidence-bucket-gap': tokens.spacing.xl,
    '--local-evidence-bucket-title-gap': tokens.spacing.md,
    '--local-evidence-bucket-title-color': tokens.color.text.primary,
    '--local-evidence-bucket-title-size': tokens.font.size.textSm,
    '--local-evidence-bucket-title-weight': tokens.font.weight.semibold,
    '--local-evidence-bucket-hint-color': tokens.color.text.tertiary,
    '--local-evidence-bucket-hint-size': tokens.font.size.textXs,
    '--local-evidence-note-color': tokens.color.text.tertiary,
    '--local-evidence-note-size': tokens.font.size.textXs,
    '--local-evidence-note-gap': tokens.spacing.lg,
  },
};
